import { useContext, useState } from "react";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { useExportAccountStatementMutation } from "../../../hooks/api/mutations/useAccounting";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";
import { useSelector } from "react-redux";

const useDownloadStatement = ({ closeWidget, chartAccountId }) => {
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [statementFormat, setStatementFormat] = useState("PDF");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedStore, setSelectedStore] = useState();
  const [entrySource, setEntrySource] = useState();

  const exportAccountStatement = useExportAccountStatementMutation();

  const handleDownloadStatement = (values) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));

    const payload = cleanObject({
      chart_account_id: chartAccountId,
      download_format: statementFormat.toLowerCase(),
      start_date: startDate,
      end_date: endDate,
      entry_source: entrySource,
      store_id: selectedStore,
    });

    exportAccountStatement.mutate(payload, {
      onSuccess: (res) => {
        triggerToast(
          "Account statement will be generated and sent to your email.",
          "success",
        );
        closeWidget();
      },
      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  return {
    handleDownloadStatement,
    exportAccountStatement,
    statementFormat,
    setStatementFormat,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    entrySource,
    setEntrySource,
    selectedStore,
    setSelectedStore,
    storeList,
  };
};

export default useDownloadStatement;
